import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="new-post"
// Automatically scrolls to and highlights a newly added post
export default class extends Controller {
  connect() {
    // Small delay to ensure DOM is fully updated
    setTimeout(() => {
      this.element.scrollIntoView({ behavior: 'smooth', block: 'center' })
      this.element.classList.add('forum-post-highlight')
      
      setTimeout(() => {
        this.element.classList.remove('forum-post-highlight')
      }, 3000)
      
      // Re-trigger turbo:load for any listeners
      document.dispatchEvent(new Event('turbo:load'))
    }, 100)
  }
}
